// @flow

import type { APIError } from '../types'

export function getErrorAction(
  type: string,
  error: APIError,
  statusText: ?string
): Object {
  return {
    type: type,
    payload: {
      status: error.response.status,
      statusText: statusText || error.response.statusText
    }
  }
}

export function removeNonQuestMakerRoleOrganizations(user) {
  let validOrganizations = []

  user.organizations.forEach(function (org) {
    if (
      org.roles.indexOf('qm_publisher') > -1 ||
      org.roles.indexOf('qm_editor') > -1 ||
      org.roles.indexOf('qm_internal_review') > -1 ||
      org.roles.indexOf('qm_platform_review') > -1 ||
      org.roles.indexOf('qm_copy_editor') > -1 ||
      org.roles.indexOf('qm_external_review') > -1 ||
      org.roles.indexOf('qm_external_review') > -1 ||
      org.roles.indexOf('qm_mentor_author') > -1 ||
      org.roles.indexOf('qm_quest_manager') > -1
    ) {
      validOrganizations.push(org)
    }
  })

  user.organizations = validOrganizations

  return user
}

export function handlePotentialDefaultOrgRoleIssue(user) {
  // if the default organization doesn't have proper roles, set default org
  //  to be the next one and also pull in the roles from that org as well
  if (
    !(user.organization_roles.indexOf('qm_publisher') > -1) &&
    !(user.organization_roles.indexOf('qm_editor') > -1) &&
    !(user.organization_roles.indexOf('qm_internal_review') > -1) &&
    !(user.organization_roles.indexOf('qm_platform_review') > -1) &&
    !(user.organization_roles.indexOf('qm_copy_editor') > -1) &&
    !(user.organization_roles.indexOf('qm_external_review') > -1) &&
    !(user.organization_roles.indexOf('qm_mentor_author') > -1) &&
    !(user.organization_roles.indexOf('qm_quest_manager') > -1)
  ) {
    user.org_id = user.organizations[0].id
    user.org_name = user.organizations[0].name
    user.organization_roles = user.organizations[0].roles
  }

  return user
}

export function doesUserHaveAppAccess(user: Object): boolean {
  return user.organizations.length > 0
}



// WEBPACK FOOTER //
// ./src/utils/actions.js